import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import TicketForm from "./components/TicketForm";
import TicketList from "./components/TicketList";
import { getSessionStoragePrefs, setSessionStoragePrefs } from "./Storage";
import TicketDetails from "./components/TicketDetails";
import ChatTabsList from "./components/ChatTabsList";
import { TICKET_ACTIVE_COMPONENT, TICKET_ACTIVE_ID } from "./globals";
export default function Tickets() {
    var _a = useState([]), tickets = _a[0], setTickets = _a[1];
    var _b = useState(), activeTicketId = _b[0], setActiveTicketId = _b[1];
    //export this
    var TicketComponentNames;
    (function (TicketComponentNames) {
        TicketComponentNames["TicketList"] = "TicketList";
        TicketComponentNames["TicketDetail"] = "TicketDetail";
        TicketComponentNames["TicketForm"] = "TicketForm";
    })(TicketComponentNames || (TicketComponentNames = {}));
    var _c = useState(TicketComponentNames[(getSessionStoragePrefs(TICKET_ACTIVE_COMPONENT) != null
        ? getSessionStoragePrefs(TICKET_ACTIVE_COMPONENT)
        : TicketComponentNames.TicketList)]), activeComponentName = _c[0], setActiveComponentName = _c[1];
    var openTicket = function (ticketId) {
        setSessionStoragePrefs(TICKET_ACTIVE_ID, ticketId);
        setActiveTicketId(ticketId);
        setActiveComponentName(TicketComponentNames.TicketDetail);
    };
    useEffect(function () {
        setSessionStoragePrefs(TICKET_ACTIVE_COMPONENT, activeComponentName);
    }, [activeComponentName]);
    var backToList = function () {
        setSessionStoragePrefs(TICKET_ACTIVE_ID, null);
        setActiveComponentName(TicketComponentNames.TicketList);
    };
    var showForm = function () {
        setActiveComponentName(TicketComponentNames.TicketForm);
    };
    return (_jsxs(_Fragment, { children: [(function () {
                switch (activeComponentName) {
                    case TicketComponentNames.TicketDetail: {
                        return (_jsx(TicketDetails, { activeTicketId: activeTicketId, backToList: backToList }));
                    }
                    case TicketComponentNames.TicketForm: {
                        return (_jsx(TicketForm, { backToList: backToList, openTicket: openTicket, setTickets: setTickets, tickets: tickets }));
                    }
                    case TicketComponentNames.TicketList: {
                        return (_jsx(TicketList, { openTicket: openTicket, setTickets: setTickets, tickets: tickets, showForm: showForm }));
                    }
                    default:
                        return _jsx(_Fragment, {});
                }
            })(), activeComponentName == TicketComponentNames.TicketList ? (_jsx(ChatTabsList, {})) : (_jsx(_Fragment, {}))] }));
}
